import React, { FC } from 'react'

import {
  Container,
  Name,
  NamePlaceholder,
  ThumbnailPlaceholder,
} from './ProfileDocument.styles'

interface ProfileDocumentSkeletonProps {}

export const ProfileDocumentPlaceholder: FC<ProfileDocumentSkeletonProps> = ({
  children,
}) => {
  return (
    <Container>
      <ThumbnailPlaceholder>{children}</ThumbnailPlaceholder>
      <Name>
        <NamePlaceholder />
      </Name>
    </Container>
  )
}
